import "./Events.css";
import Container from "react-bootstrap/Container";
import { Row, Col, Button, Spinner } from "react-bootstrap";

import axios from "../../network/api";
import { useState, useEffect } from "react";
import { baseUrl } from "../../network/Constants";
import viewMoreIcon from "../../assets/right-arrow.svg";

function ViewMoreEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchEvent();
  }, []);

  const fetchEvent = (props) => {
    setLoading(true)
    axios
      .get(baseUrl + "/app/events/")
      .then(async (response) => {
        setEvents(response.data);
        setLoading(false)
        console.log("huyyaEvents: " + JSON.stringify(response.data));
      })
      .catch((error) => {
        console.log(error);
        setLoading(false)
      });
  };

  return (
    <section className="events py-5" id="events">
      {events && (
        <Container>
          <div className="section-title">Events</div>
          { loading ?  <div className="loader"><Spinner className="loading-color"/></div>:  <Row>
            {events &&
              events.map((item, index) => {
                return (
                  <>
                    <Col lg={4}>
                      <div className="p-0 d-flex justify-content-center pt-3">
                        <img
                          className="img-fluid event-img"
                          src={item.event_image}
                        ></img>
                      </div>
                    </Col>
                  </>
                );
              })}
          </Row> }
         
        </Container>
      )}
    </section>
  );
}

export default ViewMoreEvents;
